import { useState, useRef, useMemo } from 'react';
import { categoryColors, areaColors } from '../utils/colors';

const allCategories = Object.keys(categoryColors);
const allAreas = Object.keys(areaColors);

export const useCalendarState = (currentUser) => {
  const [open, setOpen] = useState(false);
  const [tempEvent, setTempEvent] = useState({});
  const [currentView, setCurrentView] = useState('dayGridMonth');
  // 自動更新（両画面共通でローカルストレージ管理）
  const [autoUpdate, setAutoUpdateState] = useState(() => {
    try { return JSON.parse(localStorage.getItem('shared_autoUpdate')) || false; } catch { return false; }
  });
  const setAutoUpdate = (value) => {
    setAutoUpdateState(value);
    localStorage.setItem('shared_autoUpdate', JSON.stringify(value));
  };
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [isSaving, setIsSaving] = useState(false);

  // OFFにしたものをローカルストレージで管理（初期は全ON）
  const [disabledCategories, setDisabledCategories] = useState(() => {
    try { return JSON.parse(localStorage.getItem('root_disabledCategories')) || []; } catch { return []; }
  });
  const [disabledAreas, setDisabledAreas] = useState(() => {
    try { return JSON.parse(localStorage.getItem('root_disabledAreas')) || []; } catch { return []; }
  });

  const selectedCategories = useMemo(() => allCategories.filter(v => !disabledCategories.includes(v)), [disabledCategories]);
  const selectedAreas = useMemo(() => allAreas.filter(v => !disabledAreas.includes(v)), [disabledAreas]);

  const setSelectedCategories = (selected) => {
    const disabled = allCategories.filter(v => !selected.includes(v));
    setDisabledCategories(disabled);
    localStorage.setItem('root_disabledCategories', JSON.stringify(disabled));
  };
  const setSelectedAreas = (selected) => {
    const disabled = allAreas.filter(v => !selected.includes(v));
    setDisabledAreas(disabled);
    localStorage.setItem('root_disabledAreas', JSON.stringify(disabled));
  };
  
  const calendarRef = useRef(null);

  const toggleDrawer = (open) => () => {
    setIsDrawerOpen(open);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const setDefaultEvent = (dateStr) => {
    const defaultStart = `${dateStr}T00:00`;
    const defaultEnd = `${dateStr}T00:00`;
    setTempEvent({
      date: dateStr,
      notes: '',
      title: '',
      start: defaultStart,
      end: defaultEnd,
      startTime: '00:00',
      endTime: '00:00',
      category: '社会',
      person: currentUser?.name || currentUser?.username || '',
      area: '本社'
    });
  };

  return {
    // State
    open,
    setOpen,
    tempEvent,
    setTempEvent,
    currentView,
    setCurrentView,
    autoUpdate,
    setAutoUpdate,
    isDrawerOpen,
    setIsDrawerOpen,
    isSaving,
    setIsSaving,
    selectedCategories,
    setSelectedCategories,
    selectedAreas,
    setSelectedAreas,
    calendarRef,
    
    // Methods
    toggleDrawer,
    handleClose,
    setDefaultEvent
  };
};